import { LoginPhoneInput } from "./LoginPhoneInput";
import { Login as BaseLogin } from "../../login/Login";

export type Props = {
  onCancel?: () => any;
  onChangeState?: (
    state: `IDLE` | `IN_PROGRESS` | `CANCELLED` | `ERROR` | `SUCCESS`,
    errorMessage: string | null
  ) => any;
};

function Login(props: Props) {
  const { onCancel = () => {}, onChangeState = () => {} } = props;

  return (
    <BaseLogin
      provider={`phone_number`}
      helperTexts={{
        ENTER_CREDENTIAL: [
          [`Enter your`, `Mobile Phone Number`],
          [],
          [`We'll send you a`, `Text Message`],
          [`with a`, `Login Code`],
        ],
        OTP_SENT: [
          [`Check your`, `Text Messages`],
          [],
          [`Enter the`, `Login`, `we sent you`],
        ],
      }}
      helperSubtext={{
        ENTER_CREDENTIAL: null,
        OTP_SENT: `Message may be delayed slightly. \nPlease be patient`,
      }}
      credentialComponent={({
        state: { uiState, isSending, isVerifying, isSuccess, credential },
        setCredential,
      }) => {
        return (
          <LoginPhoneInput
            show={uiState === `ENTER_CREDENTIAL`}
            disabled={isSending || isVerifying || isSuccess}
            value={credential}
            onChange={(phoneNumber) => {
              setCredential({ credential: phoneNumber });
            }}
          />
        );
      }}
      onCancel={onCancel}
    />
  );
}

export { Login };
